import * as React from 'react';
import { Dispatch } from 'redux';
import { useDrop } from 'react-dnd';

import { StoreState } from '../../../reducers';
import { StyledDropTarget } from './styles';
import { DndItemTypes } from '../../../typings/dnd';
import { moveDriveItem } from '../../../containers/DriveItemList/actions';

interface DropTargetProps {
	folderId: number;
	index: number;
	isLast?: boolean;
	dispatch: Dispatch<StoreState>;
}

const DropTarget = ({ folderId, index, isLast, dispatch }: DropTargetProps) => {
	const [{ isOver, canDrop }, drop] = useDrop({
		accept: DndItemTypes.DRIVE_ITEM,
		canDrop: (item, monitor) => {
			const { index: sourceIndex } = monitor.getItem();
			return index !== sourceIndex && index !== sourceIndex + 1;
		},
		drop: (item, monitor) => {
			const { index: sourceIndex } = monitor.getItem();
			dispatch(moveDriveItem(folderId, sourceIndex, index));
		},
		collect: monitor => ({
			isOver: !!monitor.isOver(),
			canDrop: !!monitor.canDrop(),
		}),
	});

	return (
		<StyledDropTarget
			ref={drop}
			canDrop={isOver && canDrop}
			isLast={isLast}
		/>
	);
};

export default DropTarget;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/DropTarget/index.tsx